export default function current_store(state = null, action) {
    switch (action.type) {
        case 'CURRENT_STORE_SET':
            return action.payload
        default:
            return state
    }
} 